import styled from 'styled-components'

import { NATIVE_BASE_COLORS, COLOR, FONT_SIZE } from '../../themes'

export const StyleDeleteRepeatModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 32px;

  .repeat-header-modal {
    color: ${NATIVE_BASE_COLORS.TEXT[900]};
    font-family: NunitoSansBold;
    font-size: ${FONT_SIZE.SM};
  }
`

export const StyleDeleteRepeatModalContent = styled.div`
  padding: 0px 32px;

  .description {
    font-family: NunitoSansSemiBold;
    font-size: ${FONT_SIZE.XS};
    color: ${NATIVE_BASE_COLORS.TEXT[700]};
  }
`

export const StyleDeleteRepeatModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 32px 32px 24px 32px;

  .submit-button {
    display: flex;
    width: 100%;
    height: 48px;
    padding: 10px 12px;
    justify-content: center;
    background-color: ${NATIVE_BASE_COLORS.ERROR[500]};
    outline: none;
    border: 0px;
    border-radius: 4px;
    font-family: NunitoSansRegular;
    font-size: ${FONT_SIZE.SM};
    color: ${COLOR.WHITE};
    cursor: pointer;
  }
`
